import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AppService } from "src/app/core/services/app.service";
import { OnlineCredit } from "../../models/DTO/onlineCustomer.model";

@Component({
	selector: "app-stored-credit-card",
	templateUrl: "./stored-credit-card.component.html",
	styleUrls: ["../../../modules/online-order/online-order.component.scss"],
})
export class StoredCreditCardComponent implements OnInit {
	@Input() customerCreditCards: OnlineCredit[];
	@Input() orderAmount: number;

	@Input() paymentTypeSelected: string;
	@Output() paymentTypeSelectedChange = new EventEmitter<string>();

	selectedCardValue: OnlineCredit;

	creditOptions: OnlineCredit[] = [];

	constructor(public app: AppService) {}

	ngOnInit(): void {
		this.creditOptions.push(
			new OnlineCredit({
				displayName: "New Credit Card",
				type: "CC",
				token: "newCard",
			})
		);
		this.creditOptions = this.creditOptions.concat(this.customerCreditCards);
	}

	selectCreditCard() {
		const displayObject = this.app.references.creditCardTypeToDisplayObject(undefined, this.selectedCardValue.type);
		if (this.selectedCardValue.token !== "newCard") {
			this.app.confirmation.confirm({
				message: `Charge your order to ${displayObject.name} ending in ${this.selectedCardValue.displayName.substring(
					this.selectedCardValue.displayName.length - 4
				)}?`,
				accept: async () => {
					this.paymentTypeSelectedChange.emit(this.selectedCardValue.token);
				},
				reject: async () => {
					this.app.confirmation.close();
				},
			});
		} else {
			this.paymentTypeSelectedChange.emit(this.selectedCardValue.token);
		}
	}
}
